import { DialogController } from 'aurelia-dialog';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { autoinject, newInstance, computedFrom } from 'aurelia-framework';
import { ValidationController, ValidationRules } from 'aurelia-validation';
import { BootstrapGroupRenderer } from 'framework/aurelia_tools/bootstrap-group-renderer';
import { UsersEmail } from 'model/users-locations';
import { ValidationHelper } from 'support/validation';

@autoinject
export class UsersEmailDialog {
  private routerSubscription: Subscription;
  private model: UsersEmail = null;

  constructor(private dialogController: DialogController, private ea: EventAggregator, private validationHelper: ValidationHelper, @newInstance() private validationController: ValidationController, validationRenderer: BootstrapGroupRenderer) {
    validationRenderer.allowedParents = 'bs-form-input, as-form-richtexteditor';
    this.validationController.addRenderer(validationRenderer);
  }

  activate(model: UsersEmail) {
    this.model = model;
    model.from
  }

  attached() {
    this.routerSubscription = this.ea.subscribe('router:navigation:complete', () => this.dialogController.cancel());
    ValidationRules
      .ensureObject<UsersEmail>().required()
      .ensure(model => model.subject).displayName('Subject').required()
      .ensure(model => model.message).displayName('Message').required()
      .on(this.model);
  }

  detached() {
    if (this.routerSubscription != null)
      this.routerSubscription.dispose();
  }

  @computedFrom('model.from')
  get from() {
    return `${this.model.from.name} <${this.model.from.emailAddress}>`;
  }

  async ok() {
    await this.validationHelper.validate(this.validationController) && this.dialogController.ok(this.model);
  }
}
